import { createSlice } from "@reduxjs/toolkit";
import { SELECTED_SCREEN, SUB_SCREEN } from "../constants/UploadFilesConstants";

const initialState = {
    screenToShow: SELECTED_SCREEN.OFF_VIEW,
    previousScreen: SELECTED_SCREEN.OFF_VIEW,
    subScreenToShow: SUB_SCREEN.OFF_VIEW,
    imagesArray: [],
    uploadFileContainerImages: [],
    uploadedFilesThumbList: [],
    isFromMarkup: false,
    isHideFinalAddBtn: false,
};

const uploadFileSlice = createSlice({
    name: "uploadFile",
    initialState,
    reducers: {
        changeUploadFileScreen(state, action) {
            if (state.screenToShow !== action.payload) {
                state.previousScreen = state.screenToShow;
            }
            state.screenToShow = action.payload;
        },
        changePreviousScreen(state, action) {
            state.previousScreen = action.payload;
        },
        changeUploadFileSubScreen(state, action) {
            state.subScreenToShow = action.payload;
        },
        changeUploadFileBothScreen(state, action) {
            uploadFileSlice.caseReducers.changeUploadFileScreen(state, { payload: action.payload.newScreen });
            uploadFileSlice.caseReducers.changeUploadFileSubScreen(state, { payload: action.payload.newSubScreen });
        },
        updateImagesArray(state, action) {
            // Iterate over the array and convert elements to string
            action.payload.forEach((item) => {
                if (item.shapeList.length > 0) {
                    item.shapeList.forEach((element, index) => {
                        if (typeof element !== "string") {
                            const shapeInString = JSON.stringify(element);
                            item.shapeList[index] = shapeInString;
                        }
                    });
                }

                if (item.undoList.length > 0) {
                    item.undoList.forEach((element, index) => {
                        if (typeof element !== "string") {
                            const shapeInString = JSON.stringify(element);
                            item.undoList[index] = shapeInString;
                        }
                    });
                }
            });
            state.imagesArray = action.payload;
        },
        deleteImageById(state, action) {
            state.imagesArray = state.imagesArray.filter((image) => image.id !== action.payload);
        },
        updateImagesArrayAtId(state, action) {
            const index = state.imagesArray.find((image) => image.id === action.payload.id);
            if (index >= 0) {
                action.payload.shapeList.forEach((element, index2) => {
                    if (typeof element !== "string") {
                        const shapeInString = JSON.stringify(element);
                        action.payload.shapeList[index2] = shapeInString;
                    }
                });

                action.payload.undoList.forEach((element, index2) => {
                    if (typeof element !== "string") {
                        const shapeInString = JSON.stringify(element);
                        action.payload.undoList[index2] = shapeInString;
                    }
                });

                state.imagesArray[index] = action.payload;
            }
        },
        updatePropertyOfImageAtID(state, action) {
            const image = state.imagesArray.find((img) => img.id == action.payload.imgID);
            if (image) {
                image[action.payload.prop] = action.payload.newValue;
            }
        },
        setUploadFileContainerImageArray(state, action) {
            state.uploadFileContainerImages = action.payload;
        },
        addUploadFileContainerImageInArray(state, action) {
            state.uploadFileContainerImages.push(action.payload);
        },
        deleteUploadFileContainerImageByName(state, action) {
            state.uploadFileContainerImages = state.uploadFileContainerImages.filter((image) => image.imageName !== action.payload);
        },
        changeIsFromMarkupValue(state, action) {
            state.isFromMarkup = action.payload;
        },
        setUplodedFilesThumbListArray(state, action) {
            state.uploadedFilesThumbList = action.payload;
        },
        addUploadedFileInThumbList(state, action) {
            state.uploadedFilesThumbList.push(action.payload);
        },
        deleteUploadedFileFromThumbList(state, action) {
            state.uploadedFilesThumbList = state.uploadedFilesThumbList.filter((image) => image.imageName !== action.payload);
        },
        setIsHideFinalAddBtn(state, action) {
            state.isHideFinalAddBtn = action.payload;
        },
    },
});

export const {
    addScreenInQueue,
    changeUploadFileScreen,
    changePreviousScreen,
    changeUploadFileSubScreen,
    changeUploadFileBothScreen,
    updateImagesArray,
    deleteImageById,
    updateImagesArrayAtId,
    updatePropertyOfImageAtID,
    setUploadFileContainerImageArray,
    addUploadFileContainerImageInArray,
    deleteUploadFileContainerImageByName,
    changeIsFromMarkupValue,
    setUplodedFilesThumbListArray,
    addUploadedFileInThumbList,
    deleteUploadedFileFromThumbList,
    setIsHideFinalAddBtn,
} = uploadFileSlice.actions;
export default uploadFileSlice.reducer;
